/* eslint-disable no-unused-vars */
import { siteConfigIds } from '@/constants/site-config-ids';
import { websiteEnv } from '@/constants/website-env';
import { useEffect } from 'react';

interface Window {
  dataLayer: any[];
  gtag: (...args: any[]) => void;
}

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

export const useGA4 = () => {
  useEffect(() => {
    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    function gtag(...args: any[]) {
      window.dataLayer.push(arguments);
    }

    gtag('js', new Date());

    // Configure GA4

    gtag('config', siteConfigIds.ga4Id);

    if (websiteEnv.isUnitedStates) {
      const allowConsent = () => {
        const option = {
          analytics_storage: 'granted',
          ad_storage: 'granted',
          ad_user_data: 'granted',
          ad_personalization: 'granted',
        };

        gtag('consent', 'update', option);
        localStorage.setItem('gtag.consent.option', JSON.stringify(option));
      };

      const denyConsent = () => {
        const option = {
          analytics_storage: 'denied',
          ad_storage: 'denied',
          ad_user_data: 'denied',
          ad_personalization: 'denied',
        };

        gtag('consent', 'update', option);
        localStorage.setItem('gtag.consent.option', JSON.stringify(option));
      };

      // Update consent based on user's previous choice
      const updateConsentFromLocalStorage = () => {
        const storedOption = localStorage.getItem('gtag.consent.option');

        if (storedOption) {
          const option = JSON.parse(storedOption);

          gtag('consent', 'update', option);
        } else {
          // If no stored option, default to denied for EU users
          denyConsent();
        }
      };

      // Set default consent
      gtag('consent', 'default', {
        analytics_storage: 'denied',
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        wait_for_update: 500,
        region: [
          'AT',
          'BE',
          'BG',
          'CY',
          'CZ',
          'DE',
          'DK',
          'EE',
          'ES',
          'FI',
          'FR',
          'GR',
          'HR',
          'HU',
          'IE',
          'IS',
          'IT',
          'LI',
          'LT',
          'LU',
          'LV',
          'MT',
          'NL',
          'NO',
          'PL',
          'PT',
          'RO',
          'SE',
          'SI',
          'SK',
          'CH',
          'GB',
        ],
      });

      gtag('set', 'ads_data_redaction', true);
      allowConsent();
    }
  }, []);
};
